import { useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { isUserLoggedIn } from '@utils'
import { useDispatch } from 'react-redux'
import { handleLogout } from '@store/actions/auth'
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'
import { Power } from 'react-feather'
import decode from 'jwt-decode'
import { Menu, MenuItem, IconButton, Avatar } from '@mui/material'
import { ExitToApp } from '@material-ui/icons'

const UserDropdown = () => {
  // ** Store Vars
  const history = useHistory()
  const dispatch = useDispatch()

  // ** State
  const [userData, setUserData] = useState(null)
  const [isMobile, setIsMobile] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const iniciaisPrimeiroUltimoNome = useRef()
  const open = useRef(false)

  //** ComponentDidMount
  useEffect(() => {
    const fetchData = async () => {
      if (isUserLoggedIn() !== null) {
        const userData = JSON.parse(localStorage.getItem('userData'))
        if (userData) {
          const decodedToken = decode(userData.access_token)
          const currentDate = new Date()
          if (decodedToken.exp * 1000 < currentDate.getTime()) {
            dispatch(handleLogout())
            history.push('/login')
          }
          setUserData(userData)
        }
      }

      const mobileCheck = window.innerWidth <= 768
      setIsMobile(mobileCheck)

      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768)
      }

      window.addEventListener('resize', handleResize)

      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    if (userData) {
      const userSplitName = userData.username.split(' ')
      const usuarioPrimeiraLetraUltimoSobrenome = userSplitName[userSplitName.length - 1][0]
      iniciaisPrimeiroUltimoNome.current = userData.username[0] + usuarioPrimeiraLetraUltimoSobrenome
    }
  }, [userData])

  const handleClose = () => {
    open.current = false
    setAnchorEl(null);
  }

  const handleClick = (event) => {
    open.current = true
    setAnchorEl(event.currentTarget);
  }

  return (
    <>
      {isMobile ?
        <>
          <IconButton onClick={event => handleClick(event)}>
            <Avatar>{iniciaisPrimeiroUltimoNome.current}</Avatar>
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={open.current}
            onClose={handleClose}
            onClick={handleClose}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={(event) => {
              event.preventDefault();
              dispatch(handleLogout());
              history.push('/login');
            }}
            >
              <div className="menu-item-content">
                <ExitToApp fontSize="small" />
                Sair
              </div>
            </MenuItem>
          </Menu>
        </> :
        <UncontrolledDropdown className='dropdown-user nav-item'>
          <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
            <div className='user-nav flex-direction-column'>
              <span className='user-name font-weight-bold'>
                {userData !== null ? userData.email : "Usuário"}
              </span>
              <span className='user-status'>{userData !== null ? userData.tipo : "Não identificado"}</span>
            </div>
          </DropdownToggle>
          <DropdownMenu right>
            {/* <DropdownItem tag={Link} to='/pages/profile'>
              <User size={14} className='mr-75' />
              <span className='align-middle'>Meu Perfil</span>
            </DropdownItem> */}
            <DropdownItem tag={Link} to='/login' onClick={() => dispatch(handleLogout())}>
              <div className="dropdown-item-content">
                <Power size={14} className='mr-75' />
                <span className='align-middle'>Sair</span>
              </div>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      }
    </>
  )
}

export default UserDropdown
